// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2TOXh","actions":"GroupTable_actions__2D1Ez","deleteModalFooter":"GroupTable_deleteModalFooter__2wt7C"};